import { Capacity } from "./capacity"
import { ProductActivityHour } from "./product-activity-hour"

export class ServiceHour {
    forProductActivity!: string
    day!: number
    productActivityHours!: ProductActivityHour[]
    capacities!: Capacity[]
    isEnabled!: boolean
  }